import React from "react";
import {
  Scale,
  FileSearch,
  Clock,
  Lock,
  MessageSquare,
  ArrowLeft,
  CheckCircle2,
} from "lucide-react";
import { Link } from "react-router-dom";
import HeaderMenu from "../../component/Navbar/headermenu";
import CustomFooter from "../../component/Footer/customFooter";

const LegalTeamsPage = () => {
  const features = [
    {
      icon: <FileSearch size={26} />,
      title: "Case File Organization",
      description:
        "Keep every brief, contract, and evidence file perfectly organized with matter-based workspaces.",
    },
    {
      icon: <MessageSquare size={26} />,
      title: "Client Communication Hub",
      description:
        "Track all client conversations, requests, and approvals in one searchable timeline.",
    },
    {
      icon: <Clock size={26} />,
      title: "Internal Review Cycles",
      description:
        "Streamline document reviews and approvals with structured workflows and clear ownership.",
    },
    {
      icon: <Lock size={26} />,
      title: "Secure & Compliant",
      description:
        "Bank-level encryption and access controls ensure client confidentiality at every step.",
    },
  ];

  const benefits = [
    "Eliminate version control chaos across case files",
    "Track every client interaction and decision point",
    "Reduce time spent searching for documents by 70%",
    "Built-in approval workflows for contract reviews",
    "Secure client portals with granular permissions",
  ];

  return (
    <>
      <HeaderMenu />
      <div className="Legal_Team_main">
        {/* Navigation */}
        {/* <div className="Legal_Team_nav">
        <div className="Legal_Team_container">
          <Link to="/" className="Legal_Team_back_link">
            <ArrowLeft size={18} />
            Back to About
          </Link>
        </div>
      </div> */}

        {/* Hero */}
        <section className="Legal_Team_hero">
          <div className="Legal_Team_container">
            <div className="Legal_Team_hero_content">
              <div className="Legal_Team_icon_box">
                <Scale size={34} />
              </div>

              <h1 className="Legal_Team_heading">
                Workflow management for legal teams
              </h1>

              <p className="Legal_Team_subheading">
                Keep case files, client communication, and internal review
                cycles tightly organized in a secure, central hub.
              </p>
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="Legal_Team_features_section">
          <div className="Legal_Team_container">
            <h2 className="Legal_Team_section_title">
              Built for the demands of legal practice
            </h2>

            <div className="Legal_Team_features_grid">
              {features.map((feature, index) => (
                <div key={index} className="Legal_Team_feature_card">
                  <div className="Legal_Team_feature_icon">{feature.icon}</div>

                  <h3 className="Legal_Team_feature_title">{feature.title}</h3>

                  <p className="Legal_Team_feature_description">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="Legal_Team_benefits_section">
          <div className="Legal_Team_container">
            <div className="Legal_Team_benefits_wrapper">
              <h2 className="Legal_Team_section_title Legal_Team_center">
                Why legal teams choose Simplifyte
              </h2>

              <div className="Legal_Team_benefits_list">
                {benefits.map((benefit, index) => (
                  <div key={index} className="Legal_Team_benefit_item">
                    <CheckCircle2 size={24} className="Legal_Team_check_icon" />

                    <p>{benefit}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="Legal_Team_cta_section">
          <div className="Legal_Team_container">
            <div className="Legal_Team_cta_box">
              <h2 className="Legal_Team_cta_title">
                Ready to bring order to your practice?
              </h2>

              <p className="Legal_Team_cta_text">
                Join legal teams who've streamlined their case management and
                client communication.
              </p>

              <button
                className="Legal_Team_cta_button"
                onClick={() =>
                  (window.location.href = "https://app.simplifyte.com")
                }
              >
                Start Free Trial
              </button>
            </div>
          </div>
        </section>
      </div>
      <CustomFooter />
    </>
  );
};

export default LegalTeamsPage;
